import { render, staticRenderFns } from "./ChooseSeat.vue?vue&type=template&id=1435b55e&scoped=true"
import script from "./ChooseSeat.vue?vue&type=script&lang=js"
export * from "./ChooseSeat.vue?vue&type=script&lang=js"
import style0 from "./ChooseSeat.vue?vue&type=style&index=0&id=1435b55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435b55e",
  null
  
)

export default component.exports